module.exports = __webpack_public_path__ + "catalog/items/stairs/split-level-stairs/Split-level-stairs.svg";